import { customAxios } from '../../common/customAxios';

export interface IPostBumpUserSellTractorResponse {
  id: string;
  lastBumpAt: string;
  bumpTimes: number;
  sellTractorId: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
  daysSinceLastBump: number | null;
}

export const postBumpUserSellTractor = (productId: string): Promise<IPostBumpUserSellTractorResponse> => {
  return customAxios.post(`/user-sell-tractor-bump/${productId}/bump`);
};
